import React from 'react';
import '../css/PDFStyles.css';
import logo from '../assets/new_logo.svg';

const teachingData = {
    "HighestScoringTask": "Designed and delivered structured face-to-face teaching program (≥4 sessions)",
    "PointsAwarded": 8,
    "SMARTSteps": [
      {
        "PhaseTitle": "Program Development and Objective Setting",
        "SubSteps": [
          "Identify a target audience and identify 4 main surgically themed teaching topics you have a passion for.",
          "Draft 3-4 ILOs (Intended Learning Outcomes) for each of the 4 surgical topics you have chosen.",
          "Develop a basic session plan and curriculum for how you want to teach each topic.",
          "Draft and send out an email/whatsapp group chat message advertising your teaching program with proposed dates and times that will most likely work for your target audience (with a link to a google sheet interest form to input emails).",
          "Prepare your surgically themed teaching program."
        ]
      },
      {
        "PhaseTitle": "Curriculum Design and Material Preparation",
        "SubSteps": [
          "Await responses (and send a few reminder messages if needed) and collect email addresses for all interested participants.",
          "Book a room well in advance to ensure all participants can attend.",
          "Send out an email/Whatsapp message to all interested participants after collecting their emails with a google form to gather any personalised interests of the group to tweak your teaching/ assess their level of knowledge of the topics you will teach in advance.",
          "Prepare your interactive teaching content (slides, video, physical props).",
          "Get feedback from peers and staff members of the medical school/ surgical consultants to ensure the content is matched to the learning level of students and is correct + confirm their attendance as observer of your teaching sessions as required by the CST application guidance."
        ]
      },
      {
        "PhaseTitle": "Delivery and Interactive Engagement",
        "SubSteps": [
          "Practice giving your teaching session individually then ideally to a small group to ensure good flow and ironing out any glitches.",
          "Utilize real-life case studies to illustrate complex concepts during each session.",
          "Prepare a Post teaching evaluation form where students can score their understanding of the topics you have covered before and after your teach.",
          "Give your first teaching session and collect any feedback to tweak or improve your next one.",
          "Reflect on how the teach went and how you can impliment the feedback, while still covering all your content."
        ]
      },
      {
        "PhaseTitle": "Feedback Collection and Immediate Adjustments",
        "SubSteps": [
          "Send out the next emails advertising next following teaching sessions with booked time and place + next pre session questionnaires.",
          "Practice your refined next teaching sessions in your full program.",
          "Give your next teaching sessions, and collect post teach feedbacks.",
          "Adjust your final teach depending on feedback.",
          "Send out final email with session details."
        ]
      },
      {
        "PhaseTitle": "Evaluation, Reflection, and Future Planning",
        "SubSteps": [
          "Give final teaching session and thank participants for their attendance + collect final feedback on any future topics they would like to be taught about.",
          "Analyse all pre and post teaching session data to show how student's understanding has improved due to your teaching.",
          "If appropriate, share this information with your medical school for potential recognition, awards, AFHEA applications.",
          "Reflect on the overall teaching experience and what you would improve or change for your next teaching cycle.",
          "Collect evidence (Checked against CST teaching guidelines) of your teaching sessions and relevant surgical consultant observation sign offs and submit to Oriel."
        ]
      }
    ]
};

// Notes to place aligned with each section
// Indices align with SMARTSteps indices
const bubbles = [
    {
        text: "Quality > Quantity: This 8-point section is high-yield. One well-structured program beats many ad-hoc sessions."
    },
    {
        text: "Tailor your curriculum to the audience's level (gathered from your pre-course survey) to score maximum points for 'Educational Principles'."
    },
    {
        text: "Interactive is key. Use case studies and physical props to differentiate from standard lectures."
    },
    {
        text: "Feedback is your evidence. Ensure your forms capture specific metrics (Likert scales) for the 'improvement' evidence."
    },
    {
        text: "The 'loop' is critical. Show how Day 1 feedback directly changed Day 2's teaching plan."
    }
];

const CSTTeachingPDF = () => {
    return (
        <div className="mm-pdf-root">
            <div className="mm-pdf-main-wrapper">
                <div className="mm-pdf-container">
                    
                    <header className="mm-pdf-header">
                        <img src={logo} alt="MedMap Logo" className="mm-pdf-logo" />
                        <span className="mm-pdf-header-text">MedMap.UK</span>
                    </header>

                    <main className="mm-pdf-content">
                        <h1 className="mm-pdf-title">Teaching Experience</h1>
                        
                        <div className="mm-pdf-summary-box">
                            <p className="mm-pdf-summary-task">{teachingData.HighestScoringTask}</p>
                            <div className="mm-pdf-summary-points">{teachingData.PointsAwarded} Points Awarded</div>
                        </div>

                        <div className="mm-pdf-intro">
                            <p>
                                <strong>Teaching experience</strong> is a key domain in the Core Surgical Training (CST) application process. 
                                It is one of the highest-yield sections where candidates can secure maximum points relatively easily by following a structured approach. 
                                By designing a high-quality program and collecting robust feedback, you can ensure you meet the top criteria.
                            </p>
                        </div>

                        {teachingData.SMARTSteps.map((phase, index) => (
                            <div key={index} className="mm-pdf-section">
                                {/* Pro Tip Bubble aligned with section */}
                                {bubbles[index] && (
                                    <div className="mm-pdf-bubble">
                                        {bubbles[index].text}
                                    </div>
                                )}

                                <div className="mm-pdf-phase-title-wrapper">
                                    <div className="mm-pdf-phase-number">{index + 1}</div>
                                    <div className="mm-pdf-phase-title">{phase.PhaseTitle}</div>
                                </div>
                                <ul className="mm-pdf-list">
                                    {phase.SubSteps.map((step, stepIndex) => {
                                        // Extract number if it exists
                                        const match = step.match(/^(\d+\.)\s*(.*)/);
                                        const number = match ? match[1] : '';
                                        const text = match ? match[2] : step;

                                        return (
                                            <li key={stepIndex} className="mm-pdf-list-item">
                                                {number && <span className="mm-pdf-list-number">{number}</span>}
                                                {text}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        ))}
                    </main>

                    <footer className="mm-pdf-footer-section">
                        <div className="mm-pdf-footer-content">
                            <img src={logo} alt="MedMap Logo" className="mm-pdf-footer-logo" />
                            <div className="mm-pdf-cta-text">
                                Track your progress and unlock the rest of the 4 CST domains at MedMap.UK
                            </div>
                            <a href="https://medmap.uk" className="mm-pdf-cta-button">
                                Start Your Journey
                            </a>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default CSTTeachingPDF;

